const SearchProducts = (Alpine: any) => {
    Alpine.data('SearchProducts', () => ({
        query: '',
        results: [],
        loading: false,

        init() {
            const urlParams = new URLSearchParams(window.location.search);
            this.query = urlParams.get('s') || '';

            if (this.query.trim()) {
                this.searchProducts();
            }
        },

        searchProducts() {
            if (!this.query.trim()) {
                this.results = [];
                return;
            }

            this.loading = true;
            fetch(`https://${window.shopify_algolia.app_id}-dsn.algolia.net/1/indexes/*/queries`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Algolia-API-Key': window.shopify_algolia.api_key,
                    'X-Algolia-Application-Id': window.shopify_algolia.app_id
                },
                body: JSON.stringify({
                    requests: [
                        {
                            indexName: 'shopify_products',
                            query: this.query,
                            params: 'hitsPerPage=5&highlightPreTag=%3Cem%3E&highlightPostTag=%3C%2Fem%3E&attributesToHighlight=title'
                        }
                    ]
                })
            })
            .then(res => res.json())
            .then(data => {
                this.results = data.results[0].hits;
                console.log(this.results);
                this.loading = false;
            })
            .catch(() => {
                this.results = [];
                this.loading = false;
            });
        }
    }));
}

export default SearchProducts;
